import React, { useContext } from "react";
import { Store } from "../../Store";
import { Col, Container, Row } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";

const WelcomeScreen = () => {
  const { state } = useContext(Store);
  const { noticeContent, userInfo, myOrders } = state; // Assuming transactions are part of the state
  // const navigate = useNavigate();

  function getGreeting() {
    const hours = new Date().getHours();
    if (hours < 12) return "Good morning";
    if (hours < 18) return "Good afternoon";
    return "Good evening";
  }
  // console.log('myOrders',myOrders)

  function calculateSalesToday() {
    const today = new Date().toLocaleDateString("en-US");
    return myOrders
      .filter(
        (transaction) =>
          transaction.status === "completed" &&
          new Date(transaction.actionTimestamp).toLocaleDateString("en-US") === today
      )
      .reduce((total, transaction) => total + transaction.totalAmount, 0)
      .toFixed(2);
  }

  function calculateSalesThisMonth() {
    const currentMonth = new Date().getMonth();
    return myOrders
      .filter(
        (transaction) => 
          transaction.status === "completed" &&
          new Date(transaction.actionTimestamp).getMonth() === currentMonth
      )
      .reduce((total, transaction) => total + transaction.totalAmount, 0)
      .toFixed(2);
  }

  const formContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    flexDirection: "column",
    // background: "url('/images/bg2.jpg') center center/cover no-repeat",
    minHeight: "40vh",
    width: "mx-auto",
  };

  return (
    <Container
      style={{
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "mx-auto",
      }}
    >
      <Row>
        <Col>
          <h2
            style={{
              textTransform: "uppercase",
              textAlign: "center",
              color: "#5d0fab",
            }}
          >
            {getGreeting()} <span>{userInfo.username}</span>
          </h2>
        </Col>
      </Row>
      <Row className="border mb-3">
        <Col
          style={{
            color: "#1cfc03",
            backgroundColor: "#19850b",
            padding: "5px",
            borderRadius: "8px",
            fontWeight: "bold",
            textTransform: "uppercase",
            textAlign: "center",
          }}
            // style={{}}
          >
            Account Balance:{" "}
            <span className="text-light">{parseFloat(userInfo?.balance).toFixed(2)}</span>
          </Col>
          </Row>
          <Row
          style={{
            textTransform: "uppercase",
            textAlign: "center",
            gap: "15px",
            alignItems: "center",
          }}
          >
          <Col
            style={{
            height: "70px",
            width: "100px",
            backgroundColor: "#8a680a",
            color: "#fff",
            borderRadius:'8px'
            }}
          >
            Sales today <br />
            <span className="fw-bold">{calculateSalesToday()}</span>
          </Col>
          <Col
            style={{
            height: "70px",
            width: "100px",
            backgroundColor: " #5d0fab",
            color: "#fff",
            borderRadius:'8px'
            }}
          >
            Sales this month <br />
            <span className="fw-bold">{calculateSalesThisMonth()}</span>
          </Col>
          </Row>
          <div style={formContainerStyle}>
        <h4 className="text-center text-danger fw-bold mt-1 border-bottom border-danger p-1">
          NOTICE BOARD
        </h4>
        <div className="text-center text-primary fw-bold mt-4 p-1 w-100 w-md-50">
          {!noticeContent?.noticeContent ? (
            <p>Loading...</p>
          ) : (
            <p>{noticeContent?.noticeContent}</p>
          )}
        </div>
      </div>
    </Container>
  );
};

export default WelcomeScreen;